import { prefixLanguage } from '@utils/urls'

export const BASE_URL = prefixLanguage('/profile/')
